import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '../constants/app.constants';
import { UserRole } from '../constants/roles.enum';
import { checkExpiration } from '../utils/expire-checker.utils';

export const PrivateWithRoleGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Si no está logueado o token caducado -> redirigir a login
  if (!auth.isUserLoggedIn()) {
    return router.createUrlTree([`/${PUBLIC_ROUTES.login}`]);
  }

  const token = auth.getDecodedToken();

  // Couriers only get the tap flow; everything else bounces to their own home.
  if (
    token.role === UserRole.REPARTO &&
    !state.url.startsWith('/' + PRIVATE_ROUTES.checkIn)
  ) {
    return router.createUrlTree([auth.homeRoute()]);
  }

  // Si tiene rol
  if (token.role) {
    if (token.role === UserRole.VISITOR) {
      const isExpired =
        checkExpiration(token.trialPeriodExpired!).hasExpired &&
        !token.subscriptionId;
      if (isExpired) {
        // si tiene rol VISITOR y trialPeriodExpired ha caducado, redirigir a suscripción
        return router.createUrlTree(['/subscription']);
      }
      // si tiene rol VISITOR y trialPeriodExpired no ha caducado, permitir acceso
      return true;
    }
    return true;
  } else {
    // si no tiene rol --> regirige al registro Específico para que complete el registro donde se asigna un rol
    return router.createUrlTree([`/${PRIVATE_ROUTES.specificSignIn}`]);
  }
};
